import { getLabel } from "@/features/schemas/services/labeller";

export const types = ["entity"];

export function format(entityKey, value) {
    // remove trailing '?' from nullable types.
    entityKey = entityKey.replace(/\?$/, "");
    return getLabel(entityKey, value);
}
